export const uid = () => Math.random().toString(36).slice(2, 10);

export const META = {
  header: { label: "Header", group: "Layout" }, hero: { label: "Hero", group: "Layout" },
  footer: { label: "Footer", group: "Layout" }, spacer: { label: "Spacer", group: "Layout" },
  divider: { label: "Divider", group: "Layout" },
  heading: { label: "Heading", group: "Content" }, text: { label: "Text", group: "Content" },
  image: { label: "Image", group: "Content" }, video: { label: "Video", group: "Content" },
  button: { label: "Button", group: "Content" }, logo: { label: "Logo", group: "Content" },
  gallery: { label: "Image Gallery", group: "Content" }, slider: { label: "Slider / Carousel", group: "Content" },
  youtube: { label: "YouTube Videos", group: "Content" },
  html: { label: "Custom HTML", group: "Content" },
  products: { label: "Product Grid", group: "Commerce" }, categories: { label: "Product Categories", group: "Commerce" },
  search: { label: "Product Search", group: "Commerce" }, cart: { label: "Cart Button", group: "Commerce" },
  pricing: { label: "Pricing Table", group: "Commerce" },
  testimonials: { label: "Testimonials", group: "Social Proof" }, reviews: { label: "Reviews", group: "Social Proof" },
  team: { label: "Team", group: "Social Proof" }, stats: { label: "Statistics", group: "Social Proof" },
  countdown: { label: "Countdown Timer", group: "Social Proof" },
  services: { label: "Services", group: "Engage" }, faq: { label: "FAQ", group: "Engage" },
  contact: { label: "Contact Form", group: "Engage" }, map: { label: "Map", group: "Engage" },
  social: { label: "Social Icons", group: "Engage" }, newsletter: { label: "Newsletter", group: "Engage" },
  cta: { label: "CTA Banner", group: "Engage" },
};

export const GROUPS = ["Layout", "Content", "Commerce", "Social Proof", "Engage"];

/* Card factories — structured data, everything editable by the website owner. */
export const makeServiceCard = () => ({
  id: uid(), name: "", image: "", description: "", includes: [],
  price: "", offerPrice: "", duration: "", details: "", faq: "",
  buttonText: "Enquire Now", buttonType: "whatsapp", buttonUrl: "",
  whatsappNumber: "", whatsappMessage: "", page: "home",
});

export const makePricingCard = () => ({
  id: uid(), name: "", subtitle: "", icon: "", price: "", offerPrice: "",
  currency: "₹", billingPeriod: "", description: "", features: [], highlighted: false,
  buttonText: "Get Started", buttonType: "whatsapp", buttonUrl: "",
  whatsappNumber: "", whatsappMessage: "", page: "home",
});

export const makeYoutubeVideo = () => ({
  id: uid(), title: "", youtubeUrl: "", description: "", thumbnail: "", order: "", active: true,
});

export const DEFAULTS = {
  header: { brandName: "", logo: "", menu: "Home, Products, Contact", ctaText: "Get in Touch", ctaLink: "#site-contact", sticky: true },
  hero: { badge: "", heading: "Your headline here", sub: "Tell visitors what makes you special.", image: "", cta1: "Explore", cta2: "Contact Us", align: "left" },
  heading: { text: "Section heading", level: "h2", align: "left" },
  text: { text: "Write something compelling about your business…", align: "left" },
  image: { src: "", alt: "", position: "center", height: "md" },
  video: { url: "" },
  button: { text: "Click me", link: "#", align: "left" },
  logo: { src: "", align: "center" },
  gallery: { images: "", cols: "3" },
  slider: { images: "" },
  products: { title: "Featured Products", count: "8", cols: "4" },
  categories: { title: "Shop by Category" },
  search: { placeholder: "Search products…" },
  cart: { text: "View Cart", align: "center" },
  pricing: {
    title: "Pricing Plans", sub: "Choose the package that fits your needs.", layout: "grid3",
    packages: [
      { ...makePricingCard(), name: "Starter", subtitle: "For small projects", price: "4,999", billingPeriod: "one-time",
        description: "Everything you need to get started.",
        features: ["Up to 5 pages", "Mobile responsive", "Basic SEO", "Contact form"],
        buttonText: "Get Started", whatsappMessage: "Hi, I am interested in the Starter package." },
      { ...makePricingCard(), name: "Professional", subtitle: "Most popular", price: "9,999", offerPrice: "7,999", billingPeriod: "one-time",
        highlighted: true, description: "For growing businesses that need more.",
        features: ["Up to 10 pages", "Premium design", "SEO setup", "WhatsApp integration", "Priority support"],
        buttonText: "Get Started", whatsappMessage: "Hi, I am interested in the Professional package." },
    ],
  },
  services: {
    title: "Our Services", sub: "", layout: "grid3",
    cards: [
      { ...makeServiceCard(), name: "Signature Service", description: "A short, clear summary of what this service includes and who it is for.",
        includes: ["Initial consultation", "Dedicated point of contact", "Quality assurance", "On-time delivery"],
        price: "₹4,999", duration: "3–5 days", buttonText: "Enquire Now",
        whatsappMessage: "Hi, I am interested in your Signature Service." },
      { ...makeServiceCard(), name: "Premium Service", description: "Describe the extra value and outcomes customers get with this package.",
        includes: ["Everything in Signature", "Priority scheduling", "Extended support", "Progress updates"],
        price: "₹9,999", offerPrice: "₹7,999", duration: "7–10 days", buttonText: "Get a Quote",
        whatsappMessage: "Hi, I would like a quote for your Premium Service." },
    ],
  },
  youtube: {
    title: "Watch Our Videos", sub: "", layout: "grid3",
    videos: [{ ...makeYoutubeVideo(), title: "Your video title", description: "Short description of the video." }],
  },
  team: { title: "Meet the Team", items: "Asha Rao|Founder\nVikram Shah|Operations" },
  stats: { items: "1200+|Happy Clients\n98%|Satisfaction" },
  testimonials: { title: "What People Say", items: "Ananya|Absolutely loved it!\nVikram|Flawless experience, start to finish." },
  reviews: { title: "Top Rated", items: "Priya|5|Great quality\nRahul|4.5|Good value" },
  faq: { title: "Common Questions", items: "Question one?|Answer one.\nQuestion two?|Answer two." },
  contact: { title: "Get in Touch", showForm: true },
  map: { address: "Mumbai, India" },
  social: { align: "center" },
  newsletter: { title: "Stay in the loop", sub: "Get updates and exclusive offers." },
  countdown: { title: "Offer ends in", target: "" },
  cta: { title: "Ready to get started?", button: "Contact Us", link: "#site-contact" },
  spacer: { height: "48" },
  divider: {},
  html: { html: "<p>Custom HTML block</p>" },
  footer: { description: "", columns: "Shop|All Products, Deals\nCompany|About, Contact", copyright: "", showSocial: true },
};

export function makeSection(type) {
  const props = JSON.parse(JSON.stringify(DEFAULTS[type] || {}));
  for (const k of ["cards", "packages", "videos"]) {
    if (Array.isArray(props[k])) props[k].forEach((c) => { c.id = uid(); });
  }
  return { id: uid(), type, hidden: false, hideMobile: false,
           props,
           style: { bg: "", color: "", padY: "md", align: "", radius: "" } };
}

/* Build the initial editor document from the selected theme — theme stays the base design. */
export function defaultDoc(theme = {}, store = {}) {
  const s = theme.site || {};
  const sections = [makeSection("header"), makeSection("hero")];
  const hero = sections[1];
  hero.props.heading = theme.hero?.headline || store.name || "Welcome";
  hero.props.sub = theme.hero?.subline || store.business_info?.description || "";
  hero.props.image = theme.hero?.image || theme.preview || "";
  hero.props.badge = theme.hero?.badge || theme.category || "";
  hero.props.cta1 = theme.hero?.cta1 || "Explore";
  hero.props.cta2 = theme.hero?.cta2 || "Contact Us";
  if (s.about?.title) {
    const h = makeSection("heading"); h.props.text = s.about.title; sections.push(h);
    const t = makeSection("text"); t.props.text = s.about.body || ""; sections.push(t);
  }
  if (s.items?.cards?.length && store.type !== "ecommerce") {
    const sv = makeSection("services");
    sv.props.title = s.items.title || "What We Offer";
    sv.props.cards = s.items.cards.map((c) => ({
      ...makeServiceCard(), name: c.name || "", description: c.desc || "",
      buttonText: "Enquire Now", buttonType: "none",
    }));
    sections.push(sv);
  }
  if (store.type === "ecommerce") sections.push(makeSection("products"));
  if (s.stats?.length) { const st = makeSection("stats"); st.props.items = s.stats.map((x) => `${x.value}|${x.label}`).join("\n"); sections.push(st); }
  if (s.team?.length) { const tm = makeSection("team"); tm.props.items = s.team.map((x) => `${x.name}|${x.role}`).join("\n"); sections.push(tm); }
  if (s.testimonials?.length) { const ts = makeSection("testimonials"); ts.props.items = s.testimonials.map((x) => `${x.name}|${x.text}`).join("\n"); sections.push(ts); }
  if (s.faq?.length) { const f = makeSection("faq"); f.props.items = s.faq.map((x) => `${x.q}|${x.a}`).join("\n"); sections.push(f); }
  if (s.cta?.title) { const c = makeSection("cta"); c.props.title = s.cta.title; c.props.button = s.cta.button || "Get in Touch"; sections.push(c); }
  sections.push(makeSection("contact"));
  sections.push(makeSection("footer"));
  return { design: { colors: {}, font: "", body_font: "", radius: "" }, sections };
}

export const FIELDS = {
  header: [{ k: "brandName", t: "text", l: "Brand name (blank = store name)" }, { k: "logo", t: "image", l: "Logo" },
    { k: "menu", t: "text", l: "Menu items (comma separated)" }, { k: "ctaText", t: "text", l: "CTA button text" },
    { k: "ctaLink", t: "text", l: "CTA link" }, { k: "sticky", t: "toggle", l: "Sticky header" }],
  hero: [{ k: "badge", t: "text", l: "Badge" }, { k: "heading", t: "text", l: "Heading" }, { k: "sub", t: "textarea", l: "Subheading" },
    { k: "image", t: "image", l: "Hero image" }, { k: "cta1", t: "text", l: "Primary button" }, { k: "cta2", t: "text", l: "Secondary button" },
    { k: "align", t: "align", l: "Alignment" }],
  heading: [{ k: "text", t: "text", l: "Heading text" }, { k: "level", t: "select", l: "Level", opts: ["h1", "h2", "h3"] }, { k: "align", t: "align", l: "Alignment" }],
  text: [{ k: "text", t: "textarea", l: "Paragraph" }, { k: "align", t: "align", l: "Alignment" }],
  image: [{ k: "src", t: "image", l: "Image" }, { k: "alt", t: "text", l: "Alt text" },
    { k: "position", t: "select", l: "Focal position (crop)", opts: ["center", "top", "bottom", "left", "right"] },
    { k: "height", t: "select", l: "Height", opts: ["sm", "md", "lg"] }],
  video: [{ k: "url", t: "text", l: "Embed URL (YouTube embed or mp4)" }],
  button: [{ k: "text", t: "text", l: "Button text" }, { k: "link", t: "text", l: "Link" }, { k: "align", t: "align", l: "Alignment" }],
  logo: [{ k: "src", t: "image", l: "Logo image" }, { k: "align", t: "align", l: "Alignment" }],
  gallery: [{ k: "images", t: "images", l: "Images (one URL per line)" }, { k: "cols", t: "select", l: "Columns", opts: ["2", "3", "4"] }],
  slider: [{ k: "images", t: "images", l: "Slides (one URL per line)" }],
  products: [{ k: "title", t: "text", l: "Title" }, { k: "count", t: "select", l: "Products shown", opts: ["4", "8", "12"] },
    { k: "cols", t: "select", l: "Columns", opts: ["2", "3", "4"] }],
  categories: [{ k: "title", t: "text", l: "Title" }],
  search: [{ k: "placeholder", t: "text", l: "Placeholder" }],
  cart: [{ k: "text", t: "text", l: "Button text" }, { k: "align", t: "align", l: "Alignment" }],
  pricing: [{ k: "title", t: "text", l: "Title" }, { k: "sub", t: "text", l: "Subtitle (optional)" },
    { k: "layout", t: "select", l: "Layout", opts: [["grid3", "3 columns"], ["grid4", "4 columns"], ["featured", "Featured highlight"], ["minimal", "Minimal list"]] },
    { k: "packages", t: "cards", of: "pricing", l: "Pricing packages" }],
  services: [{ k: "title", t: "text", l: "Title" }, { k: "sub", t: "text", l: "Subtitle (optional)" },
    { k: "layout", t: "select", l: "Layout", opts: [["grid3", "3 columns"], ["grid2", "2 columns"]] },
    { k: "cards", t: "cards", of: "service", l: "Service cards" }],
  youtube: [{ k: "title", t: "text", l: "Title" }, { k: "sub", t: "text", l: "Subtitle (optional)" },
    { k: "layout", t: "select", l: "Layout", opts: [["grid3", "3 columns"], ["grid2", "2 columns"], ["featured", "Featured + small"], ["list", "Single column"]] },
    { k: "videos", t: "cards", of: "youtube", l: "Videos" }],
  team: [{ k: "title", t: "text", l: "Title" }, { k: "items", t: "textarea", l: "Team — Name|Role per line" }],
  stats: [{ k: "items", t: "textarea", l: "Stats — Value|Label per line" }],
  testimonials: [{ k: "title", t: "text", l: "Title" }, { k: "items", t: "textarea", l: "Name|Quote per line" }],
  reviews: [{ k: "title", t: "text", l: "Title" }, { k: "items", t: "textarea", l: "Name|Rating|Review per line" }],
  faq: [{ k: "title", t: "text", l: "Title" }, { k: "items", t: "textarea", l: "Question|Answer per line" }],
  contact: [{ k: "title", t: "text", l: "Title" }, { k: "showForm", t: "toggle", l: "Show contact form" }],
  map: [{ k: "address", t: "text", l: "Address shown on map" }],
  social: [{ k: "align", t: "align", l: "Alignment" }],
  newsletter: [{ k: "title", t: "text", l: "Title" }, { k: "sub", t: "text", l: "Subtext" }],
  countdown: [{ k: "title", t: "text", l: "Title" }, { k: "target", t: "text", l: "Target date (YYYY-MM-DD)" }],
  cta: [{ k: "title", t: "text", l: "Title" }, { k: "button", t: "text", l: "Button text" }, { k: "link", t: "text", l: "Button link" }],
  spacer: [{ k: "height", t: "text", l: "Height (px)" }],
  divider: [],
  html: [{ k: "html", t: "textarea", l: "Custom HTML" }],
  footer: [{ k: "description", t: "textarea", l: "Footer description" },
    { k: "columns", t: "textarea", l: "Link columns — Title|link, link per line" },
    { k: "copyright", t: "text", l: "Copyright text (blank = auto)" }, { k: "showSocial", t: "toggle", l: "Show social icons" }],
};
